module.exports = __webpack_public_path__ + "static/media/lapis.efd79679.png";